import React from 'react';
import formatDate from 'date-fns/format';
import parse from 'date-fns/parse';

import { useTranslation } from '@lyearn/i18n';
import { cn } from '@lyearn/style';
import { Box, Typography } from '@lyearn/ui';
import TimePicker, { FORMAT_24H } from '@/components/TimePicker';

import { FrequencyComponentProps } from '../../../types';

const CLASSES = {
  container: 'w-1/2',
  label: 'mx-12',
  input: 'flex flex-1',
};

const TimeOfDay = ({
  value,
  onChange,
  classes,
  disabled,
  size,
}: FrequencyComponentProps & {
  classes?: {
    container?: string;
    label?: string;
    input?: string;
  };
}) => {
  const { t } = useTranslation();

  const displayValue = parse(value.time, FORMAT_24H, new Date());
  return (
    <Box className={cn('flex w-1/2 flex-row items-center', classes?.container)}>
      <Typography
        className={cn(CLASSES.label, classes?.label)}
        variant={size === 'medium' ? 'body-short-02' : 'body-short-01'}>
        {t('Common:At')}
      </Typography>
      <TimePicker
        className={cn(CLASSES.input, classes?.input)}
        disabled={disabled}
        size={size}
        value={displayValue}
        onChange={(date) => {
          onChange({ ...value, time: formatDate(date, FORMAT_24H) });
        }}
      />
    </Box>
  );
};

export default React.memo(TimeOfDay);
